import { studentsControllerGetEnrolledPrograms } from "@oneapp/data";
import type { EnrolledProgram, ProfilesData } from "../../store/useAuthStore";
import { getWebGatewayHeaders } from "./gatewayHeaders";

export async function fetchEnrolledProgramsForHandoff(
  accessToken: string,
  profilesData: ProfilesData,
): Promise<EnrolledProgram[]> {
  const uad = profilesData.unified_account_details?.user_account_details;
  const defaultProfile =
    profilesData.unified_account_details?.profiles?.find(
      (p) => p.is_default_profile,
    ) ?? profilesData.unified_account_details?.profiles?.[0];

  const gradeId = uad?.grade?.gradeId ?? 0;
  const examsParam = defaultProfile?.exams
    ?.map((e) => e.examId)
    .filter((id): id is number => id != null)
    .join(",");

  const enrolledResponse = (await studentsControllerGetEnrolledPrograms(
    {
      grade: gradeId,
      processEnrollment: true,
      ...(examsParam ? { exams: examsParam } : {}),
    },
    {
      clientName: "oneApp",
      headers: getWebGatewayHeaders(`Bearer ${accessToken}`),
    },
  )) as { data?: { programs?: EnrolledProgram[] } } | undefined;

  const programs = enrolledResponse?.data?.programs;
  if (!Array.isArray(programs) || programs.length === 0) {
    return [];
  }
  return programs;
}
